import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteData';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-compass-3-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              {siteInfo.description.slice(0, 80)}...
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">
              资源分类
            </h3>
            <ul className="space-y-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">
              快捷链接
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="#faq"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  常见问题
                </a>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">
              联系方式
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line text-primary-400"></i>
                <span>{siteInfo.contactInfo.email}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-phone-line text-primary-400"></i>
                <span>{siteInfo.contactInfo.phone}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-wechat-line text-primary-400"></i>
                <span>微信：{siteInfo.contactInfo.wechat}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="w-full px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            © {new Date().getFullYear()} {siteInfo.name} 版权所有
          </p>
          <div className="flex items-center gap-4 text-sm text-foreground-500">
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
              隐私政策
            </a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
              使用条款
            </a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}